import { TextInput } from 'react-admin';

/**
 * Plain textarea-style input with helper text reminding the editor to wrap
 * italic words in <em>...</em>. We don't sanitize — the public site renders
 * via dangerouslySetInnerHTML inside controlled places (only `<em>` is used
 * in headlines per the design). If the school adds richer fields, switch to
 * TiptapInput for that source.
 */
export function ItalicHeadlineInput(props) {
  return (
    <TextInput
      multiline
      minRows={2}
      fullWidth
      helperText='Wrap italic words in <em>…</em>. e.g. "Enlightening <em>your path</em>"'
      {...props}
    />
  );
}
